import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/gabarito/400.css';
import '@fontsource/gabarito/500.css';
import '@fontsource/gabarito/600.css';
import '@fontsource/gabarito/700.css';
import '@fontsource/gabarito/800.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
